import React from "react";

import Table from "../common/Table";
import { Link } from "react-router-dom";

const FacultiesResultList = ({ data, match }) => {
  const { cid } = match.params;

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "subject_name",
      label: "مضمون",
      content: (e) => (
        <Link to={`/mis/results/classes/${cid}/${e.subject_id}`}>
          {e.subject_name}
        </Link>
      ),
    },
    { path: "teacher_name", label: "استاد" },
    { path: "credits", label: "کریدت" },
    { path: "student_count", label: "تعداد محصل" },
    { path: "passed", label: "کامیاب" },
    { path: "failed", label: "ناکام" },
    { path: "option" },
  ];

  return <Table data={data} columns={columns} />;
};

export default FacultiesResultList;
